import React from "react";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCheck, faChevronDown } from "@fortawesome/pro-regular-svg-icons";

import { FixedPositionedDropdown } from "src/base-components/FixedPositionedDropDown";
import { Pill } from "src/base-components/Pill";
import { Icon } from "src/design-system/Icon";

export type RolePillOption = {
  key: string;
  label: string;
};

type Props = {
  dataLoc: string;
  options: RolePillOption[];
  selectedKey: string;
  disabled?: boolean;
  icon?: IconProp;
  onSelect: (key: string) => void;
};

export const RolePillDropdown: React.FC<Props> = ({
  dataLoc,
  options,
  selectedKey,
  disabled = false,
  icon,
  onSelect,
}) => (
  <FixedPositionedDropdown<string, string>
    buttonClassName="h-fit w-fit rounded border-transparent bg-transparent p-0"
    buttonDataLoc={`${dataLoc}-trigger`}
    dataLoc={dataLoc}
    disabled={disabled}
    elements={options.map((option) => ({
      key: option.key,
      value: option.label,
    }))}
    listMatchesButtonWidth={false}
    placement="bottom start"
    renderButtonValue={(value) => (
      <Pill
        dataLoc={`${dataLoc}-pill`}
        fontType="text"
        size="sm"
        variant="gray"
      >
        {icon && <Pill.Icon icon={icon} />}
        <Pill.Text>{value ?? ""}</Pill.Text>
        {!disabled && <Pill.Icon icon={faChevronDown} />}
      </Pill>
    )}
    renderValue={({ value, selected }) => (
      <div
        className="flex flex-1 items-center gap-x-2"
        data-loc={`${dataLoc}-option-${value}`}
      >
        <span className="overflow-hidden">{value}</span>
        {selected && (
          <span className="ml-auto">
            <Icon icon={faCheck} size="sm" variant="active" />
          </span>
        )}
      </div>
    )}
    selected={selectedKey}
    onSelect={(key) => onSelect(key)}
  />
);
